(function () {
  const mobileQuery = window.matchMedia('(max-width: 990px)');

  function setupMobileMenu() {
    const button = document.querySelector('[data-menu-toggle]');
    const nav = document.querySelector('[data-nav]');
    if (!button || !nav || button.dataset.mobileMenuReady === 'true') return;

    button.dataset.mobileMenuReady = 'true';
    const openLabel = button.getAttribute('aria-label') || 'Open menu';

    function setOpen(open) {
      nav.classList.toggle('is-open', open);
      document.body.classList.toggle('mobile-menu-open', open);
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-label', open ? 'Close menu' : openLabel);
      button.textContent = open ? '\u00d7' : '\u2630';
    }

    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setOpen(!nav.classList.contains('is-open'));
    });

    nav.addEventListener('click', function (event) {
      if (event.target === nav || event.target.closest('a')) setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && nav.classList.contains('is-open')) {
        setOpen(false);
        button.focus();
      }
    });

    mobileQuery.addEventListener('change', function (event) {
      if (!event.matches) setOpen(false);
    });

    setOpen(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupMobileMenu);
  } else {
    setupMobileMenu();
  }
})();
